import { ExportTypeConstants } from "../export-type.constants";
import { ExportTypeLabelConstants } from "../export-type-label.constants";
export const ExportTypeMap = new Map()
    .set(ExportTypeConstants.PDF, ExportTypeLabelConstants.PDF)
    .set(ExportTypeConstants.XLSX, ExportTypeLabelConstants.Excel)
    .set(ExportTypeConstants.DOCX, ExportTypeLabelConstants.Word);
